import { render, staticRenderFns } from "./EventCategory.vue?vue&type=template&id=5a1e30b1&scoped=true"
import script from "./EventCategory.vue?vue&type=script&lang=js"
export * from "./EventCategory.vue?vue&type=script&lang=js"
import style0 from "./EventCategory.vue?vue&type=style&index=0&id=5a1e30b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1e30b1",
  null
  
)

export default component.exports